import React, { memo } from "react";
import {
  borderStyles,
  CalendarLegendItem,
} from "../calendar-legend-item/calendar-legend-item";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const LegendStyle = styled.div`
  display: flex;
  width: 300px;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin: 6px auto 0;
  max-width: fit-content;
  background-color: ${(props) => props.theme.backgroundColor};
  border: 1px solid ${(props) => props.theme.informationTextBackgroundColor};
  border-radius: 4px;
`;

const LegendItemsStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Legend = () => {
  const { t } = useTranslation();
  return (
    <LegendStyle>
      <LegendItemsStyle data-test="legendItems">
        <CalendarLegendItem
          explanation={t("instabook.legend.legend_available")}
        />
        <CalendarLegendItem
          icon={"waiting"}
          position={"right"}
          explanation={t("instabook.legend.legend_waiting")}
        />
        <CalendarLegendItem
          explanation={t("instabook.legend.legend_message")}
          status={"unaivalable"}
        />
        <CalendarLegendItem
          borderStyle={borderStyles.dashed}
          explanation={t("instabook.legend.legend_full")}
          status={"disabled"}
        />
        <CalendarLegendItem
          borderStyle={borderStyles.solid}
          explanation={t("instabook.legend.legend_closed")}
          status={"disabled"}
        />
      </LegendItemsStyle>
    </LegendStyle>
  );
};
export const CalendarLegend = memo(Legend);
